// Module
var code = "<template> <dt-modal view-model.ref=\"modal\"> <div> <h2>Oisann!</h2> <div innerHtml.bind=\"message | sanitizeHTML\"></div> </div> <div slot=\"footer\"> <button class=\"r-button r-button--primary\" click.delegate=\"clickDismiss()\">${'domain.errors.dismissButton' & t}</button> </div> </dt-modal> </template> ";
// Exports
export default code;